module.exports = __webpack_public_path__ + "static/media/minus-octagon.38d0d799.svg";